import React from 'react';
import { SITE_LOGO } from '../Utils/siteConfig';

const AppLoader = ({ exiting = false }) => (
  <div
    className={`app-loader${exiting ? ' app-loader--exit' : ''}`}
    role="status"
    aria-live="polite"
    aria-label="Loading Q-Tech Contracting"
  >
    <div className="app-loader__backdrop">
      <div className="app-loader__orb app-loader__orb--1" aria-hidden="true" />
      <div className="app-loader__orb app-loader__orb--2" aria-hidden="true" />
      <div className="app-loader__orb app-loader__orb--3" aria-hidden="true" />
      <div className="app-loader__grid" aria-hidden="true" />
    </div>

    <div className="app-loader__content">
      <div className="app-loader__emblem">
        <svg className="app-loader__progress-ring" viewBox="0 0 140 140" aria-hidden="true">
          <circle className="app-loader__progress-track" cx="70" cy="70" r="62" />
          <circle className="app-loader__progress-fill" cx="70" cy="70" r="62" />
        </svg>

        <div className="app-loader__orbit" aria-hidden="true">
          <span className="app-loader__orbit-dot" />
          <span className="app-loader__orbit-dot app-loader__orbit-dot--2" />
          <span className="app-loader__orbit-dot app-loader__orbit-dot--3" />
        </div>

        <div className="app-loader__ring app-loader__ring--outer" aria-hidden="true" />
        <div className="app-loader__ring app-loader__ring--inner" aria-hidden="true" />

        <div className="app-loader__logo-wrap">
          <div className="app-loader__logo-glow" aria-hidden="true" />
          <img src={SITE_LOGO} alt="Q-Tech Contracting" className="app-loader__logo" />
          <div className="app-loader__shine" aria-hidden="true" />
        </div>
      </div>

      <div className="app-loader__status">
        <p className="app-loader__brand">Q-Tech Contracting</p>
        <p className="app-loader__text">
          Loading
          <span className="app-loader__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
        </p>
        <div className="app-loader__bar" aria-hidden="true">
          <span className="app-loader__bar-fill" />
        </div>
      </div>
    </div>
  </div>
);

export default AppLoader;
